var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{ref:_vm.CAROUSEL_ITEM,staticClass:"flex flex-none h-full items-center",attrs:{"href":_vm.item.link,"target":"_blank"}},[_c('img',{staticClass:"w-full",attrs:{"src":_vm.item.imgSrc,"alt":_vm.item.name}})])
}
var staticRenderFns = []

export { render, staticRenderFns }